<template>

    <div class="invoice-logo">
        <img :src="logo" alt="">
        <h4> {{companyName}} </h4>
    </div>

</template>


<script>

    export default {
        props: ["companyName", "logo"],
        mounted() {
        }
    }

</script>


<style scoped>
    .invoice-logo {
        width: 100%;
        background-color: rgb(230, 225, 225);
        display: flex;
        align-items: center;
    }


    .invoice-logo img {
        width: 50px;
        height: 50px;
    }

    .invoice-logo h4 {
        font-size: 16px;
        margin-left: 10px;
        color: #222;
        font-weight: bold;
        letter-spacing: 2px;
    }
</style>